const ProviderInvoiceAdditionalColumns = [
  "payment_location",
  "invoice_submit_date",
  "invoice_last_modified_date",
  "invoice_approved_date",
] as const;

export default ProviderInvoiceAdditionalColumns;
